import styled from "@emotion/styled";
import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../hooks/useRedux";

const ProvinceItem = styled(Box)(({ theme }) => ({
  textAlign: "center",
  borderLeft: "1px solid gray",
  height: "25px",
  display: "flex",
  flexDirection: "column",
}));
const MainItem = styled(Box)(({ theme }) => ({
  textAlign: "center",
  height: "25px",
  display: "flex",
  gap: "2px",
  alignItems: "center",
  justifyContent: "center",
  direction: "ltr",
}));

interface Props {
  licensePlateSerial?: string;
  firstTowDigits?: string;
  alpha?: string;
  lastThiredDigits?: string;
}
export default function CarTagView(props: Props) {
  const { vehicleInfo } = useAppSelector((state) => state.user);

  const { alpha, firstTowDigits, lastThiredDigits, licensePlateSerial } = props;
  return (
    <Box
      sx={{
        width: "80px",
        borderRadius: "5px",
        border: "1px solid gray",
        backgroundColor: "#FFD54F",
      }}
    >
      <Grid container>
        <Grid item xs={3}>
          <ProvinceItem>
            <Typography
              sx={{
                color: "#000",
                fontSize: "8px",
              }}
            >
              ایران
            </Typography>
            <Typography
              sx={{
                color: "#000",
                fontSize: "12px",
                fontFamily: "YekanBakh",
              }}
            >
              {licensePlateSerial ||
                vehicleInfo?.licensePlate?.licensePlateSerial ||
                "--"}
            </Typography>
          </ProvinceItem>
        </Grid>
        <Grid item xs={9}>
          <MainItem>
            <Typography
              sx={{
                color: "#000",
                fontSize: "14px",
              }}
            >
              {firstTowDigits ||
                vehicleInfo?.licensePlate?.firstTowDigits ||
                "--"}
            </Typography>
            <Typography
              sx={{
                color: "#000",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {alpha || vehicleInfo?.licensePlate?.alpha || "-"}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#000",
                fontWeight: "600",
                fontFamily: "YekanBakh",
              }}
            >
              {lastThiredDigits ||
                vehicleInfo?.licensePlate?.lastThiredDigits ||
                "---"}
            </Typography>
          </MainItem>
        </Grid>
      </Grid>
    </Box>
  );
}
